import { render, staticRenderFns } from "./MemberTypeCreateForm.vue?vue&type=template&id=309c3b9c&"
import script from "./MemberTypeCreateForm.vue?vue&type=script&lang=js&"
export * from "./MemberTypeCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports